import { formatNumber, wordEnding } from '@ve/services/textModifiers';
import { format, parse } from 'date-fns';
import { ru } from 'date-fns/locale';
import { TouristGroup } from '@fr/vue/types';
import { DatesAndPricesItem } from '@ve/components/hotel/datesTabs/common/types/IMapForDatesTabsStore';

const getFormatDate = (date: Date): string => `с ${format(date, 'dd MMMM', { locale: ru })}`;

const getTextPriceProduct = (shortProduct: DatesAndPricesItem | null): string => (shortProduct?.price ? formatNumber(shortProduct.price) : '');

const getTextDateProduct = (shortProduct: DatesAndPricesItem | null): string => {
    if (!shortProduct) return '';

    const startDateProduct = parse(shortProduct.startDate, 'yyyy-MM-dd', new Date());
    return getFormatDate(startDateProduct);
};

const getTextNightsProduct = (shortProduct: DatesAndPricesItem | null): string => {
    if (!shortProduct) return '';
    return `${shortProduct.nights} ${wordEnding(shortProduct.nights, 'ночь;ночи;ночей')}`;
};

const getDateText = (dateString: string | null): string => {
    if (!dateString) return '';
    const date = parse(dateString, 'yyyy-MM-dd', new Date());
    return getFormatDate(date);
};

const getTextTourists = (touristGroup: TouristGroup | null): string => {
    if (!touristGroup) return '';

    const childrenCount = touristGroup.infants + touristGroup.kids;
    let textChildren = '';
    if (childrenCount) {
        const formatOneChildren = touristGroup.infants ? 'младенец' : 'ребенок';
        textChildren = `, ${childrenCount} ${wordEnding(childrenCount, `${formatOneChildren};детей;детей`)}`;
    }

    return `${touristGroup.adults} взрослы${wordEnding(touristGroup.adults, 'й;х;х')}${textChildren}`;
};

export {
    getTextNightsProduct,
    getTextDateProduct,
    getTextPriceProduct,

    getTextTourists,
    getDateText,
};